export default {
  button: {
    create: 'Create Video',
    new: 'New Video',
    upload: 'Upload',
    create_folder: 'Create Folder',
  },
  tab: {
    dashboard: 'Dashboard',
    videos: 'Videos',
    library: 'Library',
    learning_path: 'Collections',
    learners: 'Learners',
    learner_group: 'Groups',
    academy: 'Academy',
    integrations: 'Integrations',
    hub: 'Knowledge Hub',
    email: 'Email Settings',
  },
  subtab: {
    academy_home: 'Analytics',
    academy_builder: 'Academy Builder',
    course_builder: 'Course Builder',
    academy_config: 'Configurations',
    academy_events: 'Training Events',
  },
  space: {
    create_title: 'Create Space',
    edit_title: 'Edit Space',
    subtitle: 'A dedicated space to organize content for a specific team or use case.',
    title_label: 'Name',
    title_placeholder: 'e.g. Customer Success',
    description_label: 'Description',
    description_placeholder: 'Describe the goal of this space.',
    create: 'Create space',
    save: 'Save',
    new: 'Create Team Space',
    input_error: 'Enter a name for the space',
    limit_reached: `You've reached your limit of {limit} Team Spaces.`,
    upgrade_required: `Team Spaces aren't available on your current plan. Upgrade to unlock.`,
    delete: 'Delete Space',
    delete_confirm: 'Are you sure you want to delete this space?',
    delete_description: 'This space will be deleted, along with any items in its trash.',
    delete_not_empty: 'Move or delete all content inside to delete this space.',
    access: {
      manage: 'Manage Access',
      title: 'Manage Access',
      subtitle: 'Invite users to this Team Space. Admins and owners can access all spaces without an invitation.',
      search_placeholder: 'Search by name or email',
      add: 'Add',
      no_results: 'No matching users',
      person: 'User',
      role: 'Workspace Role',
      role_info: `This is the user's workspace-level role, not their role in this specific Team Space.`,
      owner: 'Owner',
      member: 'Member',
      empty: 'No users are invited to this team space',
      roles: {
        owner: 'Owner',
        admin: 'Admin',
        academy_manager: 'Academy Manager',
        creator: 'Creator',
        editor: 'Editor',
        user: 'Viewer',
      },
    },
  },
  actions: {
    invite_team: 'Invite your team',
    workspace_settings: 'Workspace Settings',
    new: "What's New?"
  },
  guide: {
    title: 'Quick start guide',
    // title: 'Getting Started'
  },
  workspace: {
    switch: 'Switch Workspace',
  },
};
